import React from "react";
import "./TopStatusPills.css";
import EventCountdown from "../EventCountdown";
import PhotoCounts from "../PhotoCounts";
import PaceAlert from "../PaceAlert";

/**
 * TopStatusPills — the fixed top-centered stack holding the photographer's
 * status surfaces: a pill row (end-of-event countdown + photos/copies counter,
 * client request 2026-08-01) and, when the pace calls for attention, the pace
 * alert strip below it (tier 2). One shared fixed wrapper because
 * independently-centered fixed elements would overlap; children that have
 * nothing to show render null and the stack centers whatever remains. The
 * pill row wraps on narrow screens (counter drops below the countdown —
 * Zohar's fallback placement).
 */
const TopStatusPills = ({ serverUrl, eventName }) => (
  <div className="minime-top-pills-stack">
    <div className="minime-top-pills">
      <EventCountdown serverUrl={serverUrl} eventName={eventName} />
      <PhotoCounts serverUrl={serverUrl} eventName={eventName} />
    </div>
    <PaceAlert eventName={eventName} />
  </div>
);

export default TopStatusPills;
